// extracted by mini-css-extract-plugin
export default {"container":"S05_container__QRefl","dim":"S05_dim__A2Rt3","wrapper":"S05_wrapper__HcKQ0","button":"S05_button__qEt++","play":"S05_play__n72Hn"};